// Phase A flip: /done redirects to the new session recap at
// /play/recap. Legacy DoneScreen.jsx goes dormant (deleted in Phase B).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/done")({
  beforeLoad: () => {
    throw redirect({ to: "/play/recap" });
  },
  component: () => null,
});
